import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import TopMenuItems from './TopMenuItems'
import logo from '../assets/images/massHealth.png'
import { Grid, ListItemButton } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { themeSidemenu } from '../components/Style'
import '../styles/SideMenu.scss'
import config from 'config/config'
import CloseIcon from '@mui/icons-material/Close'
import ReactGA from 'react-ga4'
import { useMsal } from '@azure/msal-react'
import { connect } from 'react-redux'
import { azureLogOut } from '../store/actions/auth'
import { changeLanguage } from '../store/actions/languageActions'
import { getTransLang } from '../components/MultiLanguage/dynamic-content-translate'
import Language from '../assets/images/Language.svg'
import Settings from '../assets/images/Settings.svg'
import Logout from '../assets/images/Logout.svg'
import { useNavigate } from 'react-router-dom'

const SwipeableTemporaryDrawer = ({ isOpen, setChange, link, language, onLangChange, layout, azureLogOut, changeLang, langDetails, isProtected }) => {
  const [state, setState] = useState()
  const navigate = useNavigate()
  const [selectedLanguage, setSelectedLanguage] = useState(langDetails?.currentLanguage)
  const { instance } = useMsal()
  const lang = langDetails.currentLanguage
  const translateMenu = (name) => {
    return getTransLang(lang)[name]
  }
  useEffect(() => {
    setSelectedLanguage(langDetails?.currentLanguage)
  }, [language])

  useEffect(() => {
    setState(isOpen)
  }, [isOpen])

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }
    setState(open)
    setChange(open)
  }
  const activeMenu = window.location.pathname.slice(1).split('/')[0]
  const signOutClickHandler = () => {
    toggleDrawer(false)
    ReactGA.event({ category: 'Logout', action: 'Logout', label: 'Logout' })
    azureLogOut(instance)
  }
  const onLanguageSelection = (e) => {
    ReactGA.event({ category: 'Language selector', action: 'Selected Language', label: e.target.value })
    localStorage.setItem('language', e.target.value)
    // window.location.reload()
    changeLang(e.target.value)
    toggleDrawer(false)
  }
  const list = () => (
    <ThemeProvider theme={themeSidemenu}>
     <Box className="sideMenu-box-wrapper" role="presentation">
        <Grid sx={{ ml: 0.5, mr: 0.5 }}>
          <Grid container item xs={12} lg={12} md={12} display="flex">
            <Grid item xs={6} lg={6} md={6} sx={{ pb: 1 }}>
              {/* <Link to="/dashboard" onClick={toggleDrawer(false)}>
                <img src={logo} height="50" alt="Home of MyServices" />
              </Link> */}
              <Grid className="sideMenulogoGrid cursor-pointer">
                <ListItemButton key={'logo'} onClick={() => { navigate('/dashboard') }}>
                  <ListItemIcon sx={[config.minW24]}>
                    <img src={logo} height="50" alt="Home of MyServices" />
                  </ListItemIcon>
                  <h1 role='heading' className="logo-sidemenu-text" data-testid="logo-text"> {layout?.productName}</h1>
                </ListItemButton>
              </Grid>
            </Grid>
            <Grid item xs={6} lg={6} md={6} justifyContent="flex-end" textAlign="right">
              <CloseIcon fontSize="medium" className="cursor-pointer p02" onClick={toggleDrawer(false)}/>
            </Grid>
          </Grid>
          <List component="nav" className="sideMenu">
            {TopMenuItems.map((menu, i) => (
              <Box key={menu.route}>
                <ListItemButton disabled={isProtected && menu.name !== 'myNotices'} component="a" key={menu.name} onClick={() => { setChange(false); navigate(`/${menu.route}`) }} className={'t-decorate-none blue'} selected={activeMenu === menu.route} sx={[config.p07, config.height3]}>
                  <ListItemIcon sx={[config.minW35]}>
                    <img src={menu.icon} alt={menu.altText + 'icon'} height="20" width="20" />
                  </ListItemIcon>
                  <ListItemText primary={translateMenu(menu.name)} />
                </ListItemButton>
                {TopMenuItems.length !== i + 1 && (
                  <Divider orientation="horizontal" flexItem />
                )}
              </Box>
            ))}
          </List>
          <Divider orientation="horizontal" flexItem />
          <Grid container >
            <Grid className=" topMenuLinkLang textCenterAlign" item xs={12} lg={12} md={12} sx={{ p: 1.5 }}>
            <img src={Language} alt={'select language'} />
            <select aria-label='select language' className="language-select header" defaultValue={selectedLanguage}
            onChange={onLanguageSelection}>
                {
                  config.languages.map((item, i) => {
                    return <option key={i} value={item.value}>{item.key}</option>
                  })
                }
                </select>
            </Grid>
            <Grid className="textCenterAlign" item xs={12} lg={12} md={12}>
              <Divider orientation="horizontal" style={{ width: '100%' }} flexItem />
            </Grid>
            <Grid item xs={12} lg={12} md={12} sx={{ pl: 0 }}>
              <ListItemButton component="a" href={'/myaccounts'} key={'accounts'} onClick={toggleDrawer(false)} className={'t-decorate-underline blue textCenterAlign'} sx={[config.p07, config.height3]}>
                <ListItemIcon sx={[config.minW35]}>
                  <img src={Settings} height="16" width="16" style= {{ marginRight: '5px' }} alt='Settings' />
                </ListItemIcon>
                <ListItemText primary={layout?.settings} />
              </ListItemButton>
            </Grid>
            <Grid className="textCenterAlign" item xs={12} lg={12} md={12}>
              <Divider orientation="horizontal" style={{ width: '100%' }} flexItem />
            </Grid>
            <Grid item xs={12} lg={12} md={12}>
              <ListItemButton component="a" key={'logoutHome'} onClick={signOutClickHandler} className={'t-decorate-underline blue textCenterAlign'} sx={[config.p07, config.height3]}>
                <ListItemIcon sx={[config.minW35]}>
                  <img src={Logout} height="16" width="16" style= {{ marginRight: '5px' }} alt="logout"/>
                </ListItemIcon>
                <ListItemText primary={layout?.logout} />
              </ListItemButton>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  )

  return (
    <SwipeableDrawer anchor="left" open={state || false} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {list()}
    </SwipeableDrawer>
  )
}
const mapStateToProps = (state) => ({
  authDetails: state.auth,
  langDetails: state.language,
  isProtected: state.accountLinkReducer?.data?.data?.isProtected || (window.sessionStorage.getItem('isProtected') === 'true')
})

const mapDispatchToProps = (dispatch) => {
  return {
    azureLogOut: (instance) => dispatch(azureLogOut(instance)),
    changeLang: (lan) => dispatch(changeLanguage(lan))
  }
}

SwipeableTemporaryDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setChange: PropTypes.func.isRequired,
  language: PropTypes.string,
  onLangChange: PropTypes.func,
  link: PropTypes.string,
  azureLogOut: PropTypes.func,
  layout: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(SwipeableTemporaryDrawer)
